import "../css/style.scss";

// Our modules / classes
import MobileMenu from "./modules/MobileMenu.js";
import HeroSlider from "./modules/HeroSlider.js";
import Search from "./modules/Search.js";
import MyNotes from "./modules/MyNotes.js";
import Like from "./modules/Like.js";

// Instantiate a new object using our modules/classes
var mobileMenu = new MobileMenu();
var heroSlider = new HeroSlider();
const search = new Search();
const myNotes = new MyNotes();
const like = new Like();
